var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NavigationDrawerMenuIcon menu-icon"},[_c(_vm.getItemIcon(),{tag:"component",staticClass:"svg-icon menu-icon__icon not--active",class:_vm.name}),_c(_vm.getItemActiveIcon(),{tag:"component",staticClass:"svg-icon menu-icon__icon is--active",class:_vm.name})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }